import { createPopper } from '@popperjs/core';
import clickoutside from 'element-ui/src/utils/clickoutside';
import _ from 'lodash';
import $ from 'jquery';
import { TEXT_IMAGE_FEATURE_TOGGLE } from '@/constants';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import smartImageService from '@/services/smartImageService';
import { TranslationSettingsService } from '@/domains/translation/services/translation-settings-service';
import { SettingType } from '@/domains/translation/enums';
import { injectNamedService } from '@patsnap/tahiti-core/ioc/inject';

const LABEL_NAME_SPLIT = '-label-';
const FIGURE_VIEW = 'figures';
const ORIGIN_LABEL = 'origin-label';

export default {
    data() {
        return {
            $imagePart: null,
            showSmartImage: false,
            popperInstance: null,
            labelName: '',
            labelLang: undefined,
            smartPanelProps: {},
            showSmartImagePanel: false,
            selectorClassName: '',
            contentClassName: '',

            showSmartImageToggle: false,
            isFree: getIsFreeView(),
            smartImageService,

            rootLangProxy: '',
        };
    },
    props: {
        side: {
            type: String,
        },
    },
    directives: {
        clickoutside,
    },
    computed: {
        isInFiguresView() {
            return this.neighborName === FIGURE_VIEW;
        },
        inSingleView() {
            return _.get(this.viewParams, 'isSingleView', true);
        },
        textImageFeatureButtonTips() {
            return this.textImageFeatureStatus ? this.$t('closeTextFeature') : this.$t('openTextFeature');
        },
        textImageFeatureStatus: {
            get() {
                return this.smartImageService.textImageFeatureStatus;
            },
            set(value) {
                this.smartImageService.updateTextImageFeatureStatus(value);
            },
        },
        rootLang() {
            return this.rootLangProxy;
        },
    },
    watch: {
        '$route': {
            handler() {
                if (!this.$imagePart) return;
                if (this.isInFiguresView) {
                    // this.$imagePart.unbind('click');
                    this.$imagePart.off('click', `.${this.selectorClassName}`, this.bindPartsClick);
                } else {
                    this.$imagePart.on('click', `.${this.selectorClassName}`, this.bindPartsClick);
                }
            },
        },
        textImageFeatureStatus() {
            if (this.textImageFeatureStatus) {
                this.bindSmartImage();
            } else {
                this.unbindSmartImage();
            }
        },
    },
    methods: {
        bindSmartImage() {
            const vm = this;
            this.$nextTick(() => {
                const containerWrapper = this.inSingleView ? '.ps-single-view' : `.view-${this.side}`;
                const $imagePart = $(containerWrapper);
                // 添加class以显示下划线样式
                // $imagePart.find(`.${vm.contentClassName}`).addClass('smart-image-feature__open');
                // 原文中的parts额外添加一个class方便判断点击区域
                $imagePart.find(`.${vm.selectorClassName}`).not(`.translation-block .${vm.selectorClassName}`).addClass(ORIGIN_LABEL);
                $imagePart.on('mouseenter', `.${vm.selectorClassName}`, function() {
                    $('.pt-wording.active').addClass('wording-inactive');
                });
                $imagePart.on('mouseleave', `.${vm.selectorClassName}`, function() {
                    $('.pt-wording.active').removeClass('wording-inactive');
                });
                if (!this.isInFiguresView) $imagePart.on('click', `.${vm.selectorClassName}`, this.bindPartsClick);
                this.$imagePart = $imagePart;
            });
        },
        bindPopover(reference) {
            setTimeout(() => {
                this.showSmartImage = true;
                this.$nextTick(() => {
                    const content = this.$refs.smartImagePopover.$el;
                    const arrow = document.querySelector('#arrow');
                    this.popperInstance = createPopper(reference, content, {
                        placement: 'bottom-start',
                        strategy: 'absolute',
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 6],
                                },
                            },
                            {
                                name: 'arrow',
                                options: {
                                    element: arrow,
                                },
                            },
                        ],
                    });
                    this.popperInstance.update();
                });
            }, 250);
        },
        hidePopover() {
            if (this.showSmartImagePanel) return;
            this.showSmartImage = false;
            this.popperInstance.destroy();
            this.popperInstance = null;
        },
        showSmartPanel(params) {
            this.smartPanelProps = params;
            this.showSmartImagePanel = true;
        },
        onSmartPanelClose() {
            this.showSmartImagePanel = false;
        },
        unbindSmartImage() {
            if (this.$imagePart) {
                this.$imagePart.off('click', `.${this.selectorClassName}`, this.bindPartsClick);
                this.$imagePart.on('mouseenter', `.${this.selectorClassName}`, function() {
                    $('.pt-wording.active').addClass('wording-inactive');
                });
                this.$imagePart.on('mouseleave', `.${this.selectorClassName}`, function() {
                    $('.pt-wording.active').removeClass('wording-inactive');
                });
                // this.$imagePart.unbind();
                // this.$imagePart.find(`.${this.selectorClassName}`).removeClass('bound');
                // this.$imagePart.find(`.${this.contentClassName}`).removeClass('smart-image-feature__open');
            }
        },
        bindPartsClick(e) {
            const target = e.currentTarget;
            e.stopPropagation();
            const classList = target.classList;
            let labelId;
            let code;
            const labelName = target.innerText;
            _.forEach(classList, item => {
                if (item.includes(LABEL_NAME_SPLIT)) {
                    code = item.split(LABEL_NAME_SPLIT)[1];
                    labelId = item;
                }
            });
            if (!labelName) return;
            if (!_.includes(classList, ORIGIN_LABEL)) {
                this.labelLang = this.rootLang;
            } else {
                this.labelLang = undefined;
            }
            this.code = code;
            this.labelName = labelName;
            this.labelId = labelId;
            this.bindPopover(target);
            window.rvTrack('Smart Image Clicked Parts');
        },
        initTextImageToggleStatus() {
            const cache = localStorage.getItem(TEXT_IMAGE_FEATURE_TOGGLE);
            if (cache) {
                this.textImageFeatureStatus = cache === 'on';
            }
        },
        toggleTextImageFeature() {
            this.textImageFeatureStatus = !this.textImageFeatureStatus;
            localStorage.setItem(TEXT_IMAGE_FEATURE_TOGGLE, this.textImageFeatureStatus ? 'on' : 'off');
        },
        initSmartImageInText({ selector, content }) {
            if (this.isFree) return;
            this.selectorClassName = selector;
            this.contentClassName = content;
            this.initTextImageToggleStatus();
            if (this.textImageFeatureStatus) {
                this.bindSmartImage();
            }
            this.showSmartImageToggle = true;
        },
    },
    created() {
        const currentTranslationSettingsService = injectNamedService(TranslationSettingsService, SettingType.CURRENT);

        const getRootLang = data => {
            return data[this.side || 'left'].lang;
        };

        this.rootLangProxy = getRootLang(currentTranslationSettingsService.getModelData());
        this.disposeCurrentTranslationSettingsService = currentTranslationSettingsService.onStatesChange(state => {
            this.rootLangProxy = getRootLang(state);
        });
    },
    beforeDestroy() {
        this.unbindSmartImage();
        this.disposeCurrentTranslationSettingsService?.dispose();
    },
};
